import React, { ChangeEvent, SyntheticEvent } from 'react';
import { OrderFilters, orderStatuses, orderStatuses_orderStatuses, AdminShippingMethodsList, AdminShippingMethodsList_adminShippingMethods } from '@api/graphql/types';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import Input from '@components/Form/Input';
import { FormError } from '@root/utils/ErrorHelper';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Queries from 'api/graphql/queries';
import { ApolloQueryResult } from 'apollo-client';
import Notification from 'components/Notification';
import BoolSelect from '@components/Form/BoolSelect';

interface Props {
    onSubmit: (values: OrderFilters) => void;
    value: OrderFilters;
}

interface StateType {
    value: OrderFilters;
    changed: boolean;
    errors: FormError[];
    statuses: orderStatuses_orderStatuses[];
    shippingMethods: Array<AdminShippingMethodsList_adminShippingMethods | null>;
}

type PropType = Props & InjectedIntlProps;

class OrderListFilters extends React.Component<PropType, StateType> {
    public constructor(props: PropType) {
        super(props);

        const { id, create_at_from, create_at_to, user_ext_id, contact_name, status_id, shipping_method_id, is_admin_checked } = props.value;
        this.state = {
            changed: false,
            value: {
                id,
                create_at_from,
                create_at_to,
                user_ext_id,
                contact_name,
                status_id,
                shipping_method_id,
                is_admin_checked,
            },
            errors: [],
            statuses: [],
            shippingMethods: [],
        };
    }

    public async componentDidMount() {
        try {
            const statusResult: ApolloQueryResult<orderStatuses> = await GraphQLClient.query<orderStatuses>({ query: Queries.orderStatuses });
            const shippingMethodResult: ApolloQueryResult<AdminShippingMethodsList> = await GraphQLClient.query<AdminShippingMethodsList>({ query: Queries.adminShippingMethods });

            this.setState({
                statuses: (statusResult.data && statusResult.data.orderStatuses ? statusResult.data.orderStatuses : []),
                shippingMethods: (shippingMethodResult.data && shippingMethodResult.data.adminShippingMethods ? shippingMethodResult.data.adminShippingMethods : []),
            });
        } catch {
            Notification.error(this.props.intl.formatMessage({ id: 'notification.failed' }));
        }
    }

    public componentWillReceiveProps(props: PropType) {
        const { id, create_at_from, create_at_to, user_ext_id, contact_name, status_id, shipping_method_id, is_admin_checked } = props.value;
        this.setState({
            changed: false,
            value: {
                id,
                create_at_from,
                create_at_to,
                user_ext_id,
                contact_name,
                status_id,
                shipping_method_id,
                is_admin_checked,
            },
        });
    }

    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.order.${id}` });
    }

    private onChange = (value: any, name: string) => {
        this.setState({
            changed: true,
            value: {
                ...this.state.value,
                [name]: value,
            },
        });
    }

    private onReset = (e: SyntheticEvent) => {
        e.preventDefault();
        this.setState({value: {
            id: null,
            create_at_from: null,
            create_at_to: null,
            user_ext_id: null,
            contact_name: null,
            status_id: null,
            shipping_method_id: null,
            is_admin_checked: null,
        }}, () => {
            this.props.onSubmit(this.state.value);
        });
    }

    public render() {
        return (
            <form onSubmit={(e) => { e.preventDefault(); this.props.onSubmit(this.state.value); }}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-4 form-group">
                                <Input type="text" name='id' value={this.state.value.id || ''} onChange={this.onChange} placeholder={this.label('filter.id')} />
                            </div>
                            <div className="col-md-3 form-group">
                                <Input type="datetime" name="create_at_from" value={this.state.value.create_at_from || ''} onChange={this.onChange} isClearable={true} placeholder={this.label('filter.create_at_from')} />
                            </div>
                            <div className="col-md-3 form-group">
                                <Input type="datetime" placeholder={this.label('filter.create_at_to')} name="create_at_to" value={this.state.value.create_at_to || ''} onChange={this.onChange} isClearable={true} />
                            </div>
                            <div className="col-md-2 form-group">
                                <BoolSelect name="is_admin_checked" value={this.state.value.is_admin_checked} onChange={this.onChange} empty={this.label('filter.is_admin_checked.all')}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 form-group">
                                <Input type="text" name="user_ext_id" value={this.state.value.user_ext_id || ''} onChange={this.onChange} placeholder={this.label('filter.user_ext_id')} />
                            </div>
                            <div className="col-md-4 form-group">
                                <Input type="text" name="contact_name" value={this.state.value.contact_name || ''} onChange={this.onChange} placeholder={this.label('filter.contact_data.contact_name')} />
                            </div>
                            <div className="col-md-4 form-group">
                                <select
                                    className="form-control"
                                    name="status_id"
                                    value={this.state.value.status_id || ''}
                                    onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                                        this.onChange(e.currentTarget.value, 'status_id');
                                    }}>
                                    >
                                        <option key={'status_code-please_select'} value=''>{this.label(`status_code.please_select`)}</option>
                                    {(this.state.statuses.length > 0) && this.state.statuses.map((status: orderStatuses_orderStatuses, index: number) => {
                                        return <option key={`status_id-${index}`} value={status.id}>{status.code} ({status.title})</option>;
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 form-group">
                                <select
                                    className="form-control"
                                    name="shipping_method_id"
                                    value={this.state.value.shipping_method_id || ''}
                                    onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                                        this.onChange(e.currentTarget.value, 'shipping_method_id');
                                    }}>
                                    >
                                        <option key={'shipping_method_id-please_select'} value=''>{this.label(`shipping_method_id.please_select`)}</option>
                                    {(this.state.shippingMethods.length > 0) && this.state.shippingMethods.map((shippingMethod: AdminShippingMethodsList_adminShippingMethods | null, index: number) => {
                                        return (shippingMethod) ? (<option key={`shipping_method_id-${index}`} value={shippingMethod.id}>{shippingMethod.name}</option>) : null;
                                    })}
                                </select>
                            </div>
                            <div className="col-md-4 form-group">
                                <button type="submit" className="btn btn-primary btn-block" disabled={!this.state.changed}>
                                    {this.props.intl.formatMessage({ id: 'common.filter' })}
                                </button>
                            </div>
                            <div className="col-md-2 form-group">
                                <button className="btn btn-primary btn-block" onClick={(e: SyntheticEvent) => {
                                    e.preventDefault();
                                    this.props.onSubmit(this.state.value);
                                }}>
                                    <i className="fa fa-sync" /> {this.props.intl.formatMessage({ id: 'common.refresh' })}
                                </button>
                            </div>
                            <div className="col-md-2 form-group">
                                <button className="btn btn-danger btn-block" onClick={this.onReset}>
                                    <i className="fa fa-redo" /> {this.props.intl.formatMessage({ id: 'common.clear' })}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default compose(
    injectIntl,
)(OrderListFilters);



// WEBPACK FOOTER //
// ./src/modules/Order/components/OrderListFilters.tsx